export default __webpack_public_path__ + "static/media/speedkino_banner.6bb3dfbc.png";